/** @format */

import React, { useState, useEffect } from 'react';

import { Form, Input, InputNumber, Button, Row, Col } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useLocation, useHistory } from 'react-router-dom';

import serviceSearchProduct from '../../hooks/services/serviceSearchProduct';
import { serviceUpdatePrice, serviceUpdateStock, Service } from './services';
import { SelectAll } from './constants/select-all.constant';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import Pharmacies from '../../v2-components/Pharmacies';
import { mapOptions } from './handle/map-options.handle';
import { GetAllPharmacies } from '../../_config/utils/get-all-pharmacies.util';
import { handleSearchParams } from './handle/search-params.handle';

import './style.css';

export default function AdminStock(props) {
	//TODO REFACTOR
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location?.search);
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [searchList, setSearchList] = useState([]);
	const [product, setProduct] = useState({});
	const [options, setOptions] = useState();
	const pharmacyQueryParam = searchParams.get('pharmacy');
	const [pharmacy, setPharmacy] = useState(pharmacyQueryParam);

	const handleSearchList = async ({ target: { value } }) => {
		const checkRepeat = (str) => {
			const repeats = /(.)\1/;
			return repeats.test(str);
		};
		const containsSpecialChars = (str) => {
			const specialChars = /\[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/; //eslint-disable-line
			return specialChars.test(str);
		};

		if (value?.length > 2 && value?.length % 2 === 0 && !checkRepeat(value) && !containsSpecialChars(value)) {
			let response = await serviceSearchProduct({ value, pharmacy });
			setSearchList(response);
		} else {
			setSearchList([]);
		}
	};

	useEffect(() => {
		new Service().getPharmacies().then((response) => {
			setOptions([SelectAll[Enviroment.LANGUAGE], ...mapOptions(response?.data)]);
		});
	}, []);

	const handleCleanList = (item) => {
		setProduct(item);
		form.setFieldsValue({
			price: item.price,
			stock: item.stock,
		});
		setSearchList([]);
	};

	const handleFinishUpdate = async (item) => {
		setLoading(true);
		if (item.stock !== product.stock) await serviceUpdateStock(item.stock, product.code_internal, pharmacy);
		if (item.price !== product.price) await serviceUpdatePrice(item.price, product.code_internal, pharmacy);
		setLoading(false);
	};

	const handleSelectChange = (value) => {
		GetAllPharmacies(value, setPharmacy);
		searchParams.set('pharmacy', value);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	return (
		<div className='admin-stock-container'>
			<h1 className="ph-tracking-detail-global-title">Actualización de Stock & Precio</h1>
			<Col>
				<Pharmacies style={{ width: '50%', marginBottom: '10px' }} onChange={handleSelectChange} options={options} />
			</Col>
			<div className="ph-search-products-container">
				<Input
					type="text"
					onChange={handleSearchList}
					placeholder="Buscar productos..."
					className={`ph-search-header-input-windows ph-search-products`}
				/>
				{searchList.length > 0 && (
					<ul className="ph-search-products-list-main-container" style={{ display: 'block' }}>
						{searchList.map((item) => (
							<li className="ph-search-products-list" onClick={() => handleCleanList(item)} key={item.code_internal}>
								<div className="ph-search-products-list-description">
									<Row>
										<Col span={2} className="ph-search-header-images-search-content">
											<picture className="ph-search-products-list-image-container">
												<source className="ph-search-products-list-image" srcSet={`${item.image}`} type="image/webp" />
												<img
													className="ph-search-products-list-image"
													src={`${item.image}`}
													alt={item.editable_name}
													title={item.editable_name}
												/>
											</picture>
										</Col>
										<Col span={22} className="ph-search-header-titles-search-content">
											<h3 className="ph-search-header-titles-search-h3">{item.editable_name}</h3>
										</Col>
									</Row>
								</div>
							</li>
						))}
					</ul>
				)}
			</div>
			{'code_internal' in product && (
				<>
					<Row className="ph-stocks-product-container" align="middle">
						<Col>
							<picture>
								<source srcSet={`${product.image}`} type="image/webp" />
								<img
									className="ph-stocks-product-img"
									src={`${product.image}`}
									alt={product.editable_name}
									title={product.editable_name}
								/>
							</picture>
						</Col>
						<Col span={8}>
							<h3 className="ph-search-header-titles-search-h3">{product.editable_name}</h3>
						</Col>
						<Col>
							<b>{product.code_internal}</b>
						</Col>
					</Row>
					<Form form={form} onFinish={handleFinishUpdate}>
						<Row className="ph-stocks-form-container">
							<Col span={10}>
								<Form.Item label="Cantidad" name="stock" rules={[{ required: true, message: 'La cantidad de stock es requerida' }]}>
									<InputNumber min={0} placeholder="Cantidad" style={{ width: '95%' }} />
								</Form.Item>
							</Col>
							<Col span={10}>
								<Form.Item label="Precio" name="price" rules={[{ required: true, message: 'El precio es requerido' }]}>
									<InputNumber min={0} placeholder="precio" style={{ width: '95%' }} />
								</Form.Item>
							</Col>
						</Row>
						<Row className="ph-stocks-footer" align="middle">
							<Col span={2}>
								<Button type="primary" htmlType="submit" loading={loading}>
									Actualizar
								</Button>
							</Col>
							<Col className="ph-stocks-footer-warning">
								<QuestionCircleOutlined />
							</Col>
							<Col className="ph-stocks-footer-warning ph-stocks-footer-warning-text">
								¡Los cambios pueden tardar unos minutos en ser reflejados!
							</Col>
						</Row>
					</Form>
				</>
			)}
		</div>
	);
}
